module.exports = __webpack_public_path__ + "img/inactive-jd.0f038485.svg";